export const IMPORT_INVENTORY_FAILED_MESSAGE = 'Internal Server Error';
